import React, { useState } from "react";
import "./Faqs.css";
import icon from "../../assets/faq/image 13.png";
// import {faq_data} from "./faq_data";
import { useSelector } from "react-redux";



const Faqs = () => {

  const [openIndex, setOpenIndex] = useState(0);
  const {
    faq_data, singleFAQ
  } = useSelector(state => state.service);


  let faqs = faq_data?.categories?.find((x) => x.category_id === singleFAQ);

  return (
    <>
      <section className="garment-faqs">
        {/* Left Rail */}
        <aside className="faq-rail">
          <div className="rail-title">QUICK LINKS</div>

          <div className="rail-icon"><img src={icon} alt="" /></div>

          <div className="more-answers">
            <span>MORE ANSWERS</span>
            <ul>
              <li>ESTATE SERVICES FAQS</li>
              <li>VESSEL SERVICES FAQS</li>
              <li>MEMBERSHIP FAQS</li>
              <li>SUPPORT STAFFER FAQS</li>
              <li>SERVICES PARTNERS FAQS</li>
            </ul>
          </div>
        </aside>

        {/* Main Content */}
        <div className="faq-main">
          {/* Hero */}
          <div className="faq-hero">
            <img src={faqs?.banner_image} alt="Garment FAQs" />
            <h2>
              {faqs?.category_name}<br />
              <span>FAQs</span>
            </h2>
          </div>

          {/* FAQ List */}
          <div className="faq-list">
            {faqs?.faqs.map((item, index) => {
              const isOpen = openIndex === index;

              return (
                <div
                  key={index}
                  className={`faq-item ${isOpen ? "open" : ""} ${index === "0" ? "open" : ""}`}
                  onClick={() =>
                    setOpenIndex(isOpen ? null : index)
                  }
                >
                  <div className="faq-question">
                    <h3>{item?.question}</h3>
                    <span className="arrow">
                      <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                        <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="1.5" />
                      </svg>
                    </span>
                  </div>

                  <div className="faq-answer-wrapper">
                    <p className="faq-answer" dangerouslySetInnerHTML={{ __html: item?.answer }}></p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </section>
      <aside className="vertical-contact-label side-vertical-heading">
        <span>FAQS</span> <span className="spacer"></span> <span>{faqs?.category_name} SERVICES</span>
      </aside>
    </>
  );
};

export default Faqs;
